export default (graphComponentRef, documentId, groupId, groupName, nodeIds, setInProgress, nodeIdsPinnedOutOfGroupRef, onOpenTableViewModal, onGetGraphGroupsNodes) => {
    if (nodeIds) {
        onOpenTableViewModal === null || onOpenTableViewModal === void 0 ? void 0 : onOpenTableViewModal(documentId, {
            NodeIds: nodeIds,
            GroupName: groupName
        });
        return;
    }
    if (!groupId || !graphComponentRef.current)
        return;
    const group = graphComponentRef.current.graph.nodes.find(item => Boolean(item.tag && item.tag.GroupId && item.tag.Nodes && item.tag.GroupId === groupId));
    if (!group)
        return;
    setInProgress && setInProgress(true);
    onGetGraphGroupsNodes === null || onGetGraphGroupsNodes === void 0 ? void 0 : onGetGraphGroupsNodes(documentId, graphComponentRef, [group], nodeIdsPinnedOutOfGroupRef.current, (result) => {
        setInProgress && setInProgress(false);
        onOpenTableViewModal === null || onOpenTableViewModal === void 0 ? void 0 : onOpenTableViewModal(documentId, {
            NodeIds: result ? Array.from(result) : [],
            GroupName: groupName
        });
    }, () => {
        setInProgress && setInProgress(false);
    });
};
